export const messageConstants = {
    MESSAGE_MESSAGES: 'message:messages',
    MESSAGE_RECIPIENTS: 'message:recipients',
    MESSAGE_CLEAR: 'message:clear',
    MESSAGE_KEY: 'message:key',
};
